import { round } from 'lodash'

export const roundingNumber = (value: string) => {
    let inputValue: number | null = +value
    if (Number.isNaN(inputValue)) return
    if (!value && value !== '0') {
        inputValue = null
    }
    if (inputValue) {
        const value = round(inputValue, 2)
        inputValue = value
    }

    return inputValue?.toString()
}
